import styled from "styled-components";


export const Form = styled.form`
border:none;
color: #939393;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
` 

export const Input = styled.input`
width: 517px;
height: 48px;
padding: 14px 20px 14px 14px;
border-radius: 12px;
background: #E5E5E7;
border:none;
outline:none;
`

export const TodoAppDiv = styled.div`
display:flex;
flex-direction:column;
gap:20px;
`

export const Div = styled.div`
display: flex;
flex-direction:column;
gap:12px;
border-radius: 8px;
border:none;
`

export const Li = styled.li`
display: flex;
width: 517px;
padding: 12px 20px 12px 14px;
justify-content: space-between;
align-items: center;
border-radius: 8px;
background: #FFF;
list-style:none;
color: #000;
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 25px; 
`

export const StyledTaskListDiv = styled.div`
width:50%;
display:flex;
gap:15px;
align-items:center;
height:20px;
`

export const TimeStyle = styled.h3`
display: flex;
align-items: flex-start;
gap: 10px;
border-radius: 8px;
bachground-position: 10px 5px;
color: #80848A;
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: normal;
`

export const StyledTaskListDivTimeDelete = styled.div`
display:flex;
align-items:center;
justify-content:end;
gap:15px;
width:50%;
height:20px;
`

export const H5 = styled.h5`
display:flex;
align-items:center;
`

export const H4 = styled.h4`
width:11px;
height:11px;
border:2px solid red;
border-radius:4px;
`